import React, { useEffect, useState } from "react";
import lastpic from "../assets/lastpic.png";
import test from "../assets/Introduction.svg";
import test2 from "../assets/secondpic.png";
import bgInd1 from "../assets/part2abstract.png";
import bgInd2 from "../assets/part2abstract2.png";
import mobiletest2 from "../assets/AssessmentIntroduction.png";
import mobiletest from "../assets/mobiletest.svg";

const CTAPage = ({ CTAClicked499, CTAClicked10 }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  // Added new useEffect for mobile detection
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Initial check
    checkMobile();

    // Add event listener for window resize
    window.addEventListener("resize", checkMobile);

    // Cleanup
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const slides = [
    {
      type: "business",
      title: "Gain a comprehensive analysis for successful AI adoption",
      price: "$1000 AUD",
      description: "for an organisation assessment",
      img: isMobile ? mobiletest : test,
      bgImg: lastpic,
    },
    {
      type: "individual",
      title: "Test Your AI Skills. Get Personalized Learning Paths.",
      price: "$10 AUD",
      description: "for an Individual assessment",
      img: isMobile ? mobiletest2 : test2,
      bgImg: [bgInd1, bgInd2],
    },
  ];

  // Handle automatic sliding every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // Change slide manually on click
  const handleNextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const handlePrevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="relative w-full overflow-hidden">
      {/* Slide Container */}
      <div
        className="flex transition-transform duration-1000 ease-in-out"
        style={{ transform: `translateX(-${currentSlide * 100}%)` }}
      >
        {/* Slide Content */}
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`relative w-full flex-shrink-0 ${
              slide.type === "business"
                ? "bg-custom-color"
                : "bg-custom-color-10"
            } flex justify-center items-center`}
          >
            {/* Content for Business / Individuals */}
            <div className="relative w-full p-4 grid max-md:grid-rows-3 md:grid-cols-7 px-6 md:px-12 gap-4">
              <div
                className={`max-md:row-span-1 md:col-span-3 relative transition-opacity duration-1000 ease-in-out justify-center flex flex-col space-y-2 md:space-y-6 md:-mt-2 md:top-0`}
              >
                <div className="flex align-middle max-md:justify-center">
                  <div className="bg-[#A776FF] text-[#fff] text-sm font-bold px-6 py-2 rounded-md">
                    {index === 0 ? "For Business" : "For Individuals"}
                  </div>
                </div>
                <p className="lg:text-2xl md:text-sm font-semibold 2xl:text-4xl font-display text-white rounded max-md:text-center max-md:font-bold max-md:text-2xl max-md:leading-8">
                  {slide.title}
                </p>
                <div className="flex max-md:justify-center">
                  <p className=" rounded-full text-white text-xs font-display md:text-md lg:text-lg 2xl:text-2xl pxr-2 py-0 px-4 max-md:py-2 max-md:px-4">
                    {slide.price === "$10 AUD" && (
                      <span className="line-through text-gray-700 mr-2">
                        $30
                      </span>
                    )}
                    <span className="font-semibold">{slide.price}</span>{" "}
                    {slide.description}
                  </p>
                </div>
                <div className="flex max-md:justify-center">
                  <button
                    className="z-40 px-6 py-2 bg-white text-black border md:-mt-1 border-black rounded-full font-display font-semibold text-sm lg:text-lg shadow-lg  hover:text-white hover:bg-black hover:border-white"
                    onClick={() => {
                      slide.price === "$10 AUD" ? CTAClicked10() : CTAClicked499();
                    }}
                    
                  >
                    Get Started →
                  </button>
                </div>
              </div>
              {/* Slide Image */}
              <div className="max-md:row-span-2 md:col-span-4 relative w-full h-full flex justify-center items-center">
                <img
                  src={slide.img}
                  alt="AI introduction"
                  className="w-full h-full object-cover z-40 rounded-2xl"
                />
              </div>
              {/* Background images */}
              {!isMobile &&
                (Array.isArray(slide.bgImg) ? (
                  <>
                    <img
                      src={slide.bgImg[0]}
                      alt="Ind background1"
                      className="max-md:hidden absolute top-0 left-0"
                    />
                    <img
                      src={slide.bgImg[1]}
                      alt="Ind background2"
                      className="absolute top-0 right-0"
                    />
                  </>
                ) : (
                  <img
                    src={slide.bgImg}
                    alt="Business background"
                    className="max-md:hidden absolute top-0 left-0"
                  />
                ))}
            </div>
          </div>
        ))}
      </div>

      {/* Right Arrow Button */}
      <button
        className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-[#A776FF]/10 opacity-30 text-white px-2 py-1 rounded-full"
        onClick={handleNextSlide}
      >
        →
      </button>
      {/* Left Arrow Button */}
      <button
        className="absolute top-1/2 left-4 transform -translate-y-1/2 bg-[#A776FF]/10 opacity-30 text-white px-2 py-1 rounded-full"
        onClick={handlePrevSlide}
      >
        ←
      </button>

      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`w-2 h-2 rounded-full ${
              currentSlide === index ? "bg-white" : "bg-white/30"
            }`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default CTAPage;








